define('controllers/callcenter/auditreservations',['require','johngrid','daterangepicker'],function (require) {
    var CreateJohnGrid = require('johngrid');
    require('daterangepicker');
    return function() {
        var table = $("#tblAuditReservations"),
                columns = [{ DataField: "AuditingStatus", HeaderText: "Auditing Status" }, { DataField: "CreateDate", HeaderText: "Created" }, { DataField: "NameFirst", HeaderText: "First" },
                           { DataField: "NameLast", HeaderText: "Last" }, { DataField: "BookingName", HeaderText: "Name on Reservation" },
                           { DataField: "StartDate", HeaderText: "Check In" }, { DataField: "EndDate", HeaderText: "Check Out" }, { DataField: "Hotel" },
                           { DataField: "ConfirmationNumber", HeaderText: "Confirmation" },
                           { DataField: "Member" },
                           { DataField: "AdultCount", HeaderText: "Adults" }, { DataField: "ChildCount", HeaderText: "Children" }, { DataField: "RoomTypeCode", HeaderText: "Room Type" },
                           { DataField: "RoomRateTotal", HeaderText: "Rate" }, { DataField: "HotelTaxFeesTotal", HeaderText: "Tax" }, { DataField: "HotelFeesTotal", HeaderText: "Fees" },
                           { DataField: "RecoveryFee", HeaderText: "Recovery Fee" }, { DataField: "BookingSource", HeaderText: "Source" }, { DataField: "InvoiceNumber", HeaderText: "Invoice" },
                           { DataField: "EmailAddress", HeaderText: "Hotel Email" },
                           { DataField: "WebAddress", HeaderText: "Hotel URL" }, { DataField: "ReservationEmail", HeaderText: "Hotel Reservation Email" },
                           { DataField: "Phone_Local", HeaderText: "Hotel Phone" },
                           { DataField: "CancelationDate", HeaderText: "Canceled" }],
                dsURL = "AuditReservationsAJAX.aspx",
                grid = CreateJohnGrid(),
                auditTable = $("#tblAudits"),
                auditColumns = [{ DataField: "AuditedByUserName", HeaderText: "Auditor" }, { DataField: "TypeName", HeaderText: "Type" },
                                { DataField: "Comment" }, { DataField: "CreateDate" }],
                auditDsURL = "AuditReportAJAX.aspx",
                auditGrid = CreateJohnGrid(),
                CustomFilter = $("#CustomFilter"),
                spnCount = $("#spnCount"),
                txtFN = $("#txtFN"),
                txtLN = $("#txtLN"),
                txtSearchHotels = $(".txtSearchHotels").first(),
                txtSearchCustomers = $(".txtSearchCustomers").first(),
                FilterStatuses = $("input[name='FilterStatuses']");

        auditGrid.sorting.allowSorting = true;
        auditGrid.deleteHelpers.allowDelete = true;
        auditGrid.dsPostValues.sortClause = "CreateDate DESC";
        auditGrid.init(auditTable, auditColumns, auditDsURL);

        grid.sorting.allowSorting = true;
        grid.dsPostValues.sortClause = "StartDate";
        grid.editHelpers.init($("#auditReservation"));
        grid.editHelpers.onEdit = BindAudits;
        grid.utilities.afterSave = BindAudits;
        grid.utilities.beforeSave = function(item) {
            item.Comment = Utilities.htmlEncode(item.Comment);
        };

        function BindAudits(item) {
            auditGrid.dsPostValues.VacationDestinationId = item.PrimaryKey;
            auditGrid.databind();
        }

        //get rid of the scroll box styling upon switching to edit form
        grid.utilities.onSwapped = function () {
            var hidingTable = table.css('display') === 'none';
            table.parent().css(hidingTable ? { overflow: '', height: '' } : { overflow: 'scroll', height: '500px' });
        };

        /**
         * Returns closure func to be used for the daterange picker change event
         * @param {string} postProp 
         * @returns {function} 
         */
        var dateRangeChange = function (postProp) {
            return function(start, end) {
                grid.dsPostValues[postProp] = Utilities.getTimeFilter(start, end);
                grid.databind();
            };
        };
        Utilities.generalDateRangePicker('#checkIn_Range', dateRangeChange('checkinRange'));
        Utilities.generalDateRangePicker('#checkOut_Range', dateRangeChange('checkoutRange'));

        $("#aCustomFilter").on("click", function (e) {
            e.preventDefault();
            if (IsFilterCustomFilter()) {
                CustomFilter.hide();
                $(this).text("Apply Custom Filter");
                grid.databind();
            } else {
                CustomFilter.show();
                $(this).text("Use Default Filter");
                txtFN.focus();
            }
        });

        grid.onDataBinding = function () {
            grid.dsPostValues.FN = txtFN.val().trim();
            grid.dsPostValues.LN = txtLN.val().trim();
            grid.dsPostValues.HID = txtSearchHotels.attr("data-selectedValue");
            grid.dsPostValues.HotelSearch = txtSearchHotels.val();
            grid.dsPostValues.CustomerId = txtSearchCustomers.attr("data-selectedValue");
            grid.dsPostValues.statusTypeIds = GetSelectedStatuses();
            grid.dsPostValues.Canceled = $("#ddlFilterCanceled").val();
            grid.dsPostValues.CustomFilter = IsFilterCustomFilter();
        };

        function GetSelectedStatuses() {
            var selectedStatuses = [];
            FilterStatuses.each(function () {
                var $this = $(this),
                    checked = $this.is(":checked");
                if (checked) {
                    selectedStatuses.push($this.val());
                }
            });
            return selectedStatuses.join(",");
        }

        grid.onCreatingRows = function () {
            spnCount.text("Count: " + grid.currentDataSource.Count);
            grid.currentDataSource = grid.currentDataSource.reservationsToAudit;
        };

        function IsFilterCustomFilter() {
            return CustomFilter.css("display") == "block";
        }

        grid.init(table, columns, dsURL);
        var filterTemplate = $("#filterTemplate");
        $(".johnGridHeader", grid.$table).prepend(filterTemplate);

        grid.databind();

        Utilities.setDefaultButton(filterTemplate, $(".btnRefresh", grid.$table));

    };
});
